import { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import "../form/form-register.css";
import "react-phone-input-2/lib/bootstrap.css";
import API_URL from "../../Api/index";
import Swal from "sweetalert2";
import QRCode from "react-qr-code";
// import banner from "../../assets/img/APRE/barcode_ss.6916c490c276565cb4c1.png";
// import { Row } from "reactstrap";
import PhoneInput from "react-phone-input-2";
import { getSchool, getValidation, sendRegister } from "../../service/service";
import useDebounce from "../debounce/useDebounce";

const FormRegister = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm();
  const [school, setSchool] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedAttendees, setSelectedAttendees] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setphone] = useState("");
  const [tableCode, setTableCode] = useState([]);
  const [studentName, setStudentName] = useState([]);
  const debouncedEmail = useDebounce(email, 1000);
  const debouncedPhone = useDebounce(phone, 1000);
  const [isEmailRegistered, setIsEmailRegistered] = useState(false);
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [isPhoneRegistered, setIsPhoneRegistered] = useState(false);
  const [checkingPhone, setCheckingPhone] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [qrValue, setQrValue] = useState('');
  const qrRef = useRef(null);

  const fetchSchool = async () => {
    try {
      const response = await getSchool()
      setSchool(response);
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        text:
          error.message ||
          "Terjadi kesalahan saat mengambil data instansi. Silakan coba lagi nanti.",
      });
    }
  };

  // Cek ke backend ketika email berhenti diketik
  const registeredCheck = async () => {
    if (!debouncedEmail && !debouncedPhone) {
      setIsEmailRegistered(false);
      setIsPhoneRegistered(false);
      setStudentName("");
      return;
    }

    try {
      setCheckingEmail(true);
      setCheckingPhone(true);
      const response = await getValidation(selectedCategory, email, phone)
      if (response.status === 200 && response.data.status === "Success") {
        setIsEmailRegistered(true);
        setIsPhoneRegistered(true);
        setTableCode(response.data.data.keterangan);
        setStudentName(response.data.data.guest);
        console.log("Email atau Nomor HP terdaftar");
      } else {
        setIsEmailRegistered(false);
        setIsPhoneRegistered(false);
        setStudentName("");
      }
    } catch (err) {
      console.error("Gagal memvalidasi ", err);
      setIsEmailRegistered(false);
      setIsPhoneRegistered(false);
      setStudentName("");
    } finally {
      setCheckingEmail(false);
      setCheckingPhone(false);
    }
  };

  useEffect(() => {
    fetchSchool();
  }, []);

  useEffect(() => {
    if (
      (selectedCategory?.value === "1" || selectedCategory?.value === "3") && debouncedEmail
    ) {
      registeredCheck();
    } else if (
      selectedCategory?.value === "2" && debouncedPhone
    ) {
      registeredCheck();
    }
  }, [debouncedEmail, debouncedPhone, selectedCategory]);

  const onSubmit = async (data) => {
    try {
      setBtnLoading(true);
      const formattedPhone = data.phone.replace(/^\+/g, '');
      const keteranganData = {
        category: tableCode,
        attendance: selectedAttendees
      }

      const postData = {
        ...data,
        id_konten: API_URL.id_event,
        type_person: selectedCategory?.value,
        name: name,
        email: email,
        phone: formattedPhone,
        keterangan: JSON.stringify(keteranganData),
        sekolah: selectedSchool?.value,
        kode_referal: tableCode,
      };
      // console.log('data terkirim:', postData)
      const response = await sendRegister(postData);
      const qrCode = response?.data?.data?.register_code ?? '';
      setQrValue(qrCode);
      setShowModal(true);
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        text:
          error.message ||
          "Terjadi kesalahan saat melakukan registrasi. Silakan coba lagi nanti.",
      });
    } finally {
      setBtnLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    window.location.reload();
  }

  const handleSchoolChange = (selectedOption) => {
    setSelectedSchool(selectedOption);
  };
  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
  };

  const options = school.map((sekolah) => ({
    value: sekolah.kode_sekolah,
    label: sekolah.nama_sekolah,
  }));

  let additionalForm = null;
  let parentForm = null;

  const optionsCategory = [
    { value: '1', label: 'Student' },
    { value: '2', label: 'Orang Tua' },
    { value: '3', label: 'Instansi Pendidikan' },
    // { value: 'dinas', label: 'Dinas' },
    // { value: 'ambassador', label: 'Ambassador' },
    // { value: 'ihms', label: 'IHMS' },
    // { value: 'schoolpatner', label: 'School Patner' },
  ]

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? "hsl(var(--input) / 0.9)"
        : "hsl(var(--input) / 0.6)",
      borderRadius: '10px',
    }),
    placeholder: (base) => ({
      ...base,
      color: "hsl(var(--gold) / 0.6)",
    }),
    singleValue: (base) => ({
      ...base,
      color: '#ffffff',
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'gray' : 'black',
      backgroundColor: state.isSelected ? '#dfdfdf' : 'white',
      ':hover': {
        backgroundColor: '#e6f0ff',
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '10px',
      overflow: 'hidden',
    }),
  };

  switch (selectedCategory?.value) {
    case "2":
      parentForm = (
        <div className="form-input">
          <label htmlFor="keterangan" className="form-label">
            Nama Putra/Putri Anda :
          </label>
          <input
            type="text"
            className={`form-control `}
            id="keterangan"
            placeholder=""
            value={studentName}
            readOnly
          />
          {errors.keterangan?.message && (
            <div className="invalid-feedback">{errors.keterangan?.message}</div>
          )}
        </div>
      );
      break;
    case "3":
      additionalForm = (
        <div className="form-input">
          <label htmlFor="keterangan" className="form-label">
            Pilih Instansi
          </label>
          <Controller
            name="school"
            control={control}
            rules={{ required: "School must be selected" }}
            render={({ field }) => (
              <Select
                {...field}
                value={selectedSchool}
                onChange={(value) => {
                  handleSchoolChange(value);
                  field.onChange(value);
                }}
                options={options}
                styles={customStyles}
                className={` ${errors.keterangan?.message && "is-invalid"}`}
                placeholder="Daftar Instansi"
                isSearchable
              />
            )}
          />
          {errors.keterangan?.message && (
            <div className="invalid-feedback">{errors.keterangan?.message}</div>
          )}
        </div>
      );
      break;
    // case "schoolpatner":
    //   additionalForm = (
    //     <div className="form-input">
    //       <label htmlFor="keterangan" className="form-label">
    //         School Partner
    //       </label>
    //       <input
    //         {...register("keterangan", {
    //           required: "University Name Wajib Diisi",
    //         })}
    //         type="text"
    //         className={`form-control ${
    //           errors.keterangan?.message && "is-invalid"
    //         }`}
    //         id="keterangan"
    //         placeholder="University Name"
    //       />
    //       {errors.keterangan?.message && (
    //         <div className="invalid-feedback">{errors.keterangan?.message}</div>
    //       )}
    //     </div>
    //   );
    //   break;
    // case "dinas":
    //   additionalForm = (
    //     <div className="form-input">
    //       <label htmlFor="keterangan" className="form-label">
    //         Asal Dinas
    //       </label>
    //       <input
    //         {...register("keterangan", { required: "Nama Dinas Wajib Diisi" })}
    //         type="text"
    //         className={`form-control ${
    //           errors.keterangan?.message && "is-invalid"
    //         }`}
    //         id="keterangan"
    //         placeholder="Nama Dinas"
    //       />
    //       {errors.keterangan?.message && (
    //         <div className="invalid-feedback">{errors.keterangan?.message}</div>
    //       )}
    //     </div>
    //   );
    //   break;
    default:
      additionalForm = null;
      break;
  }

  const downloadQRCode = () => {
    const svg = qrRef.current;
    if (!svg) return;

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const image = new Image();
    const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(svgBlob);

    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);
      URL.revokeObjectURL(url);

      const pngUrl = canvas.toDataURL("image/png");

      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "qrcode.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };

    image.src = url;
  };

  return (
    <section id="form-register">
      <div className="container d-flex justify-content-center">
        <div className="form-register form">
          <div className="">
            <p className="display-title">RSVP</p>
            <h2 className="display-header">
              Konfirmasi <span className="display-gold">Kehadiran</span>
            </h2>
            <p className="text-center form-caption">
              Mohon lengkapi formulir di bawah ini sebelum 20 Juni 2026.
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="form-wrapper" >
            <div className="form-input">
              <label htmlFor="type_person" className="form-label">
                Kategori Undangan
              </label>
              <Controller
                name="type_person"
                control={control}
                rules={{ required: "Kategori wajib dipilih!" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    value={selectedCategory}
                    onChange={(value) => {
                      handleCategoryChange(value);
                      field.onChange(value);
                    }}
                    inputId="type_person"
                    options={optionsCategory}
                    styles={customStyles}
                    className={`${errors.type_person?.message && "is-invalid"}`}
                    placeholder="Pilih Kategori"
                    isSearchable
                  />
                )}
              />
              {errors.type_person?.message && (
                <div className="invalid-feedback">{errors.type_person?.message}</div>
              )}
            </div>
            {additionalForm}{" "}
            {/* Menampilkan form tambahan sesuai dengan kategori yang dipilih */}
            <div className="form-input">
              <label htmlFor="name" className="form-label">
                Nama Lengkap
              </label>
              <input
                {...register("name", { required: "Nama lengkap wajib di isi!" })}
                type="text"
                className={`form-control ${errors.name?.message && "is-invalid"}`}
                id="name"
                placeholder="Nama Lengkap"
                autoComplete="off"
                onChange={(e) => {
                  setName(e.target.value);
                  setValue("name", e.target.value);
                }}
              />
              {errors.name?.message && (
                <div className="invalid-feedback">{errors.name?.message}</div>
              )}
            </div>
            <div className="form-input">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                {...register("email", {
                  required: "Email wajib di isi!",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                    message: "Email tidak valid",
                  },
                })}
                type="text"
                className={`form-control ${errors.email?.message && "is-invalid"
                  }`}
                id="email"
                placeholder="name@example.com"
                autoComplete="off"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setValue("email", e.target.value);
                }}
              />
              {errors.email?.message && (
                <div className="invalid-feedback">{errors.email?.message}</div>
              )}
            </div>
            <div className="form-input">
              <label htmlFor="phone" className="form-label">
                No Whatsapp
              </label>
              <Controller
                name="phone"
                control={control}
                rules={{ required: "Nomor Whatsapp Wajib Diisi" }}
                render={({ field: { ref, ...field } }) => (
                  <PhoneInput
                    {...field}
                    country="id"
                    countryCodeEditable={false}
                    inputClass="phone-input"
                    containerClass="phone-container"
                    buttonClass="phone-button"
                    onChange={(value) => {
                      setphone(value);
                      setValue("phone", value);
                    }}
                  />
                )}
              />
              {errors.phone?.message && (
                <div className="text-invalids">{errors.phone?.message}</div>
              )}
            </div>
            {parentForm}
            <div className="form-input">
              <label htmlFor="attendance" className="form-label">
                Jumlah Kehadiran
              </label>
              <select
                {...register("attendance", {
                  required: "Jumlah tamu yang akan hadir wajib di isi!",
                })}
                className={`form-control ${errors.attendance?.message && "is-invalid"
                  }`}
                id="attendance"
                onChange={(e) => setSelectedAttendees(e.target.value)}
                placeholder=""
              >
                <option value="" defaultValue>Klik untuk memilih...</option>
                <option value={1}>1 Orang</option>
                <option value={2}>2 Orang</option>
                <option value={3}>3 Orang</option>
              </select>
              {errors.attendance?.message && (
                <div className="invalid-feedback">
                  {errors.attendance?.message}
                </div>
              )}
            </div>
            {/* <div className="form-input">
            <label htmlFor="tablecode" className="form-label">
              Nomor Meja Anda :
            </label>       
            <input type="text" className="form-control" value={tableCode} readOnly/>     
          </div>    */}
            <div className="form-input">
              <button
                disabled={!isEmailRegistered || !isPhoneRegistered || checkingEmail || checkingPhone || btnLoading}
                type="submit"
                className="btn-register"
              >
                {btnLoading ? "Memproses..." : "Kirim Konfirmasi"}
              </button>
            </div>
          </form>

          {showModal && (
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Registrasi Berhasil</h5>
                    <button type="button" className="btn-close" onClick={closeModal}></button>
                  </div>
                  <div className="modal-body">
                    <p>Halo, <strong>{name}</strong>!</p>
                    <div style={{ margin: '0 auto', maxWidth: 100 }}>
                      <QRCode
                        ref={qrRef}
                        value={qrValue}
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        viewBox={"0 0 256 256"}
                      />
                    </div>
                    <p className="">Kode Meja Anda: <strong>{tableCode}</strong></p>
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={downloadQRCode}>Download</button>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default FormRegister;
